import { forwardRef, type Ref, type SVGProps } from "react";
const IconAirConditioningFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 15a1 1 0 1 0 0 2 1 1 0 1 0 0-2" />
    <path d="M16 8a8 8 0 1 0 8 8 8 8 0 0 0-8-8m5.5 9.8a4.7 4.7 0 0 1-2.5.9 4.5 4.5 0 0 1-3-1.3 2.3 2.3 0 0 0-.1 3 1 1 0 0 1-.3 1.4 1 1 0 0 1-.6.2 1 1 0 0 1-.8-.5 4.4 4.4 0 0 1 .4-5.6 2.4 2.4 0 0 0-3 0 1 1 0 1 1-1.1-1.7 4.4 4.4 0 0 1 5.6.4 2.4 2.4 0 0 0 .1-3 1 1 0 0 1 1.7-1.1 4.4 4.4 0 0 1-.4 5.6 2.4 2.4 0 0 0 3 .1 1 1 0 0 1 1.3.3 1 1 0 0 1-.3 1.3" />
    <path d="M28 2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M16 26a10 10 0 1 1 10-10 10 10 0 0 1-10 10" />
  </svg>
);
const ForwardRef = forwardRef(IconAirConditioningFilledSVG);
ForwardRef.displayName = "IconAirConditioningFilled";
export { ForwardRef as IconAirConditioningFilled };
